import { put, takeLatest, all } from 'redux-saga/effects';
import TrackerActions from '@Actions/trackerActions';
import { notification } from 'antd';
import CategoryServices from '@Services/categoryServices';
import CategoryActions, { categoryActionTypes } from '../actions/categoryActions';

/**
 *
 * @param {*} action
 */
function* _createCategory(action) {
  try {
    yield put(CategoryActions.createCategoryLoading(true));
    const { payload } = action;
    const newCategory = yield CategoryServices.createCategory(payload);
    if (newCategory.success) {
      yield put(TrackerActions.trackAction(categoryActionTypes.CREATE_CATEGORY.SUCCESS, newCategory));
      notification.open({
        type: 'success',
        message: 'Category created successfully.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: newCategory?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(CategoryActions.createCategoryLoading(false));
  } catch (error) {
    yield put(CategoryActions.createCategoryLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(categoryActionTypes.CREATE_CATEGORY.ERROR, error));
  }
}

/**
 *
 */
function* createCategory() {
  yield takeLatest(categoryActionTypes.CREATE_CATEGORY.REQUEST, _createCategory);
}

/**
 *
 * @param {*} action
 */
function* _getCategories(action) {
  try {
    yield put(CategoryActions.getCategoriesLoading(true));
    const categories = yield CategoryServices.getCategories(action?.orgId, action?.page, action?.limit, action?.searchKeyword);
    yield put(CategoryActions.getCategoriesSuccess(categories));
    yield put(CategoryActions.getCategoriesLoading(false));
  } catch (error) {
    yield put(CategoryActions.getCategoriesLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(categoryActionTypes.GET_CATEGORIES.ERROR, error));
  }
}
/**
 *
 */
function* getCategories() {
  yield takeLatest(categoryActionTypes.GET_CATEGORIES.REQUEST, _getCategories);
}

/**
 *
 * @param {*} action
 */
function* _updateCategory(action) {
  try {
    yield put(CategoryActions.updateCategoryLoading(true));
    const updatedCategory = yield CategoryServices.updateCategory(action.payload);
    if (updatedCategory.success) {
      yield put(TrackerActions.trackAction(categoryActionTypes.UPDATE_CATEGORY.SUCCESS, updatedCategory.data));
      notification.open({
        type: 'success',
        message: 'Category updated successfully.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: updatedCategory.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(CategoryActions.updateCategoryLoading(false));
  } catch (error) {
    yield put(CategoryActions.updateCategoryLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(categoryActionTypes.UPDATE_CATEGORY.ERROR, error));
  }
}
/**
 *
 */
function* updateCategory() {
  yield takeLatest(categoryActionTypes.UPDATE_CATEGORY.REQUEST, _updateCategory);
}

/**
 * @param action
 */
function* _deleteCategory(action) {
  try {
    yield put(CategoryActions.deleteCategoryLoading(true));
    const category = yield CategoryServices.deleteCategory(action.payload);

    if (category.success) {
      notification.open({
        type: 'success',
        message: 'Category successfully deleted',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: category?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(CategoryActions.deleteCategoryLoading(false));
  } catch (error) {
    yield put(CategoryActions.deleteCategoryLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(categoryActionTypes.DELETE_CATEGORY.ERROR, error));
  }
}

/**
 *
 */
function* deleteCategory() {
  yield takeLatest(categoryActionTypes.DELETE_CATEGORY.REQUEST, _deleteCategory);
}

// create sub category
function* _createSubCategory(action) {
  try {
    yield put(CategoryActions.createSubCategoryLoading(true));
    const createdSubCategory = yield CategoryServices.createSubCategory(action.payload);
    if (createdSubCategory.success) {
      notification.open({
        type: 'success',
        message: 'Sub category created successfully.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: createdSubCategory?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(CategoryActions.createSubCategoryLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(CategoryActions.createSubCategoryLoading(false));
  }
}

function* createSubCategory() {
  yield takeLatest(categoryActionTypes.CREATE_SUB_CATEGORY.REQUEST, _createSubCategory);
}

// get sub category
function* _getSubCategory(action) {
  try {
    yield put(CategoryActions.getSubCategoriesLoading(true));
    const subCategories = yield CategoryServices.getSubCategories(action?.searchKeyword, action?.page, action?.limit);
    yield put(CategoryActions.getSubCategoriesSuccess(subCategories?.data));
    yield put(CategoryActions.getSubCategoriesLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
  yield put(CategoryActions.createSubCategoryLoading(false));
}

function* getSubCategories() {
  yield takeLatest(categoryActionTypes.GET_SUB_CATEGORIES.REQUEST, _getSubCategory);
}

export default function* categorySaga() {
  yield all([createCategory(), getCategories(), updateCategory(), deleteCategory(), createSubCategory(), getSubCategories()]);
}
